const getPathnameCheckoutData = (
	branchToCheckout: string,
	currentBranch: string | null | undefined,
): { haveToCheckout: true; currentBranch: string; branchToCheckout: string } | { haveToCheckout: false } => {
	if (!branchToCheckout || !currentBranch || branchToCheckout === currentBranch) return { haveToCheckout: false };
	return { haveToCheckout: true, currentBranch, branchToCheckout };
};

export default getPathnameCheckoutData;
